import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE_URL } from "../lib/site";

const SITE = "Set Up Home Theater";
const BASE = SITE_URL;

const SEO = ({
  title,
  fullTitle: titleOverride,
  description,
  path = "/",
  image = "https://customer-assets-m6fa6gv7.emergentagent.net/job_home-cinema-build/artifacts/ntpr30th_SHT-Logo-Tranparent-Txt.webp",
  jsonLd,
}) => {
  const fullTitle = titleOverride || (title ? `${title} | ${SITE}` : SITE);
  const url = `${BASE}${path}`;
  const schemas = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow, max-image-preview:large" />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_US" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="geo.region" content="US-NC" />
      <meta name="geo.placename" content="Rocky Mount, North Carolina" />
      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
